/**
 * Page-about template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
import PageAboutStory from './partials/PageAboutStory';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Page-about';

const pageAboutStoryDom = document.querySelector(`[data-page-about-story]`);

const pageAboutNavDom = document.querySelector(`[data-page-about-nav]`);
const pageAboutNavLightClass = `page-about-nav__nav--light`;
const pageAboutNavDarkClass = `page-about-nav__nav--dark`;

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.info(`${NAME} > init`);
	initNav();
	initStory();
}

/**
 * initNav - Initialize the floating nav
 */
const initNav = () => {
	Logger.info(`${NAME} > initNav`);

	if (!pageAboutNavDom) return;

	let currentNavMode = `light`;

	const thresholds = Array(101).fill().map((_, i) => i * .01);

	const observer = new IntersectionObserver(
		entries => {

			// Find the element where the bottom of the element is NOT visible
			entries.forEach(entry => {
				const bcr = entry.boundingClientRect;
				const isBottomVisible = (bcr.bottom < window.innerHeight) && bcr.bottom;
				if (!isBottomVisible) currentNavMode = entry.target.getAttribute(`data-page-about-navigable-section`);
			});

			// It's having a hard time detecting the boundries when the page is all the way at the top, so let's help it out.
			if (window.pageYOffset === 0 && document.querySelector(`.page-about-hero__content`) && document.querySelector(`.page-about-hero__content`).getAttribute(`data-page-about-navigable-section`) === `light`) {
				currentNavMode = `light`;
			}

			pageAboutNavDom.classList.remove(pageAboutNavDarkClass);
			pageAboutNavDom.classList.remove(pageAboutNavLightClass);

			if (currentNavMode === `light`) {
				pageAboutNavDom.classList.add(pageAboutNavLightClass);
			} else {
				pageAboutNavDom.classList.add(pageAboutNavDarkClass);
			}
		},
		{ threshold: thresholds }
	);

	const sectionDoms = document.querySelectorAll(`[data-page-about-navigable-section]`);

	sectionDoms.forEach((dom) => {
		observer.observe(dom);
	});

}

/**
 * initStory
 * @returns
 */
const initStory = () => {
	Logger.info(`${NAME} > initStory`);

	if (!pageAboutStoryDom) return;

	const el = new PageAboutStory(pageAboutStoryDom);
	el.init();

}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
